module.exports = __webpack_public_path__ + "img/chinesecompany239.776000ed.png";